/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_ConnectedInputs */

const cs_integrations_connected = /** @type {(inputs: Integrations_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojeno`)
};

const en_integrations_connected = /** @type {(inputs: Integrations_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected`)
};

/**
* | output |
* | --- |
* | "Connected" |
*
* @param {Integrations_ConnectedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_connected = /** @type {((inputs?: Integrations_ConnectedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_ConnectedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_connected(inputs)
	return cs_integrations_connected(inputs)
});